"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityPoolModule = void 0;
const index_1 = require("../index");
const util_1 = require("../util");
const bignumber_js_1 = require("bignumber.js");
const dayjs_1 = __importDefault(require("dayjs"));
const long_1 = __importDefault(require("long"));
const base_1 = __importDefault(require("./base"));
class LiquidityPoolModule extends base_1.default {
    create(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgCreatePool.fromPartial({
                creator: wallet.bech32Address,
                tokenADenom: params.tokenADenom,
                tokenBDenom: params.tokenBDenom,
                tokenAWeight: params.tokenAWeight.shiftedBy(18).toString(10),
                tokenBWeight: params.tokenBWeight.shiftedBy(18).toString(10),
                swapFee: params.swapFee.shiftedBy(18).toString(10),
                numQuotes: new long_1.default(params.numQuotes),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreatePool,
                value,
            }, opts);
        });
    }
    createWithLiquidity(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgCreatePoolWithLiquidity.fromPartial({
                creator: wallet.bech32Address,
                tokenADenom: params.tokenADenom,
                tokenBDenom: params.tokenBDenom,
                tokenAWeight: params.tokenAWeight.shiftedBy(18).toString(10),
                tokenBWeight: params.tokenBWeight.shiftedBy(18).toString(10),
                amountA: params.amountA.toString(10),
                amountB: params.amountB.toString(10),
                swapFee: params.swapFee.shiftedBy(18).toString(10),
                numQuotes: new long_1.default(params.numQuotes),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreatePoolWithLiquidity,
                value,
            }, opts);
        });
    }
    addLiquidity(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgAddLiquidity.fromPartial({
                creator: wallet.bech32Address,
                poolId: new long_1.default(params.poolId),
                amountA: params.amountA.toString(10),
                amountB: params.amountB.toString(10),
                minShares: params.minShares.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgAddLiquidity,
                value,
            }, opts);
        });
    }
    removeLiquidity(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgRemoveLiquidity.fromPartial({
                creator: wallet.bech32Address,
                poolId: new long_1.default(params.poolId),
                shares: params.shares.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgRemoveLiquidity,
                value,
            }, opts);
        });
    }
    stakePoolToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgStakePoolToken.fromPartial({
                creator: wallet.bech32Address,
                denom: params.denom,
                amount: params.amount.toString(10),
                duration: new long_1.default(params.duration)
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgStakePoolToken,
                value,
            }, opts);
        });
    }
    unstakePoolToken(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgUnstakePoolToken.fromPartial({
                creator: wallet.bech32Address,
                denom: params.denom,
                amount: params.amount.toString(10),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUnstakePoolToken,
                value,
            }, opts);
        });
    }
    claimPoolRewards(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = index_1.Models.MsgClaimPoolRewards.fromPartial({
                creator: wallet.bech32Address,
                poolId: new long_1.default(params.poolId),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgClaimPoolRewards,
                value,
            }, opts);
        });
    }
    /**
     * Calculates weekly LP rewards (in SWTH)
     * weeklySWTHRewards = ((INITIAL_SUPPLY) * (WEEKLY_DECAY)^(weeksFromInitalRewardsStart)) / 52
     * weeklySWTHLPRewards = weeklySWTHRewards * liquidityRewardRatio
     * @returns weekly SWTH rewards allocated to liquidityProviders (BigNumber)
    */
    getWeeklyRewards() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const WEEKLY_DECAY = new bignumber_js_1.BigNumber(0.9835);
            const MIN_RATE = new bignumber_js_1.BigNumber(0.0003);
            const INITIAL_SUPPLY = new bignumber_js_1.BigNumber(1000000000);
            const SECONDS_IN_A_WEEK = new bignumber_js_1.BigNumber(604800);
            const mintDataResponse = yield this.sdkProvider.query.inflation.MintData({});
            const mintData = mintDataResponse.mintData;
            const nowTime = new bignumber_js_1.BigNumber((0, dayjs_1.default)().unix());
            const firstBlockTime = (_a = mintData === null || mintData === void 0 ? void 0 : mintData.firstBlockTime.toNumber()) !== null && _a !== void 0 ? _a : 0;
            const difference = nowTime.minus(firstBlockTime);
            const currentWeek = difference.div(SECONDS_IN_A_WEEK).dp(0, bignumber_js_1.BigNumber.ROUND_DOWN);
            let inflationRate = WEEKLY_DECAY.pow(currentWeek);
            if (inflationRate.lt(MIN_RATE)) {
                inflationRate = MIN_RATE;
            }
            const weeklyRewards = INITIAL_SUPPLY.div(52).times(inflationRate);
            // Calculate weekly rewards earned by liquidity providers
            // Weekly LP Rewards = liquidityRewardRatio * weeklyRewards
            const distributionParams = yield this.sdkProvider.query.distribution.Params({});
            const liquidityRewardRatio = util_1.NumberUtils.bnOrZero((_b = distributionParams.params) === null || _b === void 0 ? void 0 : _b.liquidityProviderReward).shiftedBy(-18);
            return liquidityRewardRatio.times(weeklyRewards);
        });
    }
    claimMultiPoolRewards(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            if (!params.creator)
                params.creator = wallet.bech32Address;
            return yield wallet.sendTxs(params.pools.map((poolId) => ({
                typeUrl: util_1.CarbonTx.Types.MsgClaimPoolRewards,
                value: {
                    poolId: poolId,
                    creator: params.creator,
                },
            })), opts);
        });
    }
}
exports.LiquidityPoolModule = LiquidityPoolModule;
;
